import { Component, OnInit, ViewChild, Injectable, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router, ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { SimulacaoVendaWebtefService } from './simulacao-venda-webtef.service';
import { NbDialogService } from '@nebular/theme';
import { AdministrativeService } from '../../../shared/services/adiq/administrative/administrative.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { Financial } from '../../../shared/model/Financial';
import { FinancialService } from '../../../shared/services/adiq/financial/financial.service';
import { TransactionInfoBuilder } from '../../../shared/builders/TransactionInfoBuilder';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { TransactionInfo } from '../../../shared/model/TransactionInfo';
import { PinPadWebTefComponent } from '../../../shared/components/resources/pinpad-webtef.component';
import * as moment from 'moment';
import { PinPadWebTefService } from '../../../shared/services/adiq/pinpad/pinpad-webtef.service';
import { ModalSimulacaoVendaWebtefComponent } from './modal-simulacao-venda/modal-simulacao-venda-webtef.component';


enum ModalidadeTransacao {
  DEBITO = 4,
  CREDITO_VISTA = 1,
  CREDITO_PARCELADO = 2,
}

enum EtapaProcessamento {
  TRANSACAO_PINPAD_PENDENTE = 'TRANSACAO_PINPAD_PENDENTE',
  SIMULADOR_PENDENTE = 'SIMULADOR_PENDENTE',
  VENDA_TX_PENDENTE = 'VENDA_TX_PENDENTE',
  CONFIRMA_VENDA_TX_PENDENTE = 'CONFIRMA_VENDA_TX_PENDENTE',
  FINALIZADO = 'FINALIZADO',
}

enum WebTefComandos {
  BUSCAR_TERMINAL = '4200',
  CONFIGURAR_TERMINAL = '1030',
  STATUS = '1020',
  INICIALIZAR = '6666',
}


@Component({
  selector: "ngx-simulacao-venda-webtef",
  templateUrl: "./simulacao-venda-webtef.component.html",
  styleUrls: ["./simulacao-venda-webtef.component.scss"],
})
export class SimulacaoVendaWebtefComponent
  extends PinPadWebTefComponent
  implements OnInit, OnDestroy {
  @ViewChild("myTable", null)
  private myTable: DatatableComponent;

  public formSimulaVenda = null;
  public listTaxa: Array<any> = null;
  public listBandeira: Array<any> = null;
  public listTipo: Array<any> = null;
  public rowData: any = [];
  public parcelaSelecionada = null;
  public simulaVenda = null;

  selected: boolean = false;

  public valorCobrar = null;
  public valorReceber = null;
  public parcela = null;
  public valorVenda: string = null;
  public tipoTaxa = null;
  public bandeira = null;
  public modalidade = null;
  public financial: Financial;
  public pinpadStatus: boolean = true;
  public liberarSelecaoParcelas: boolean = false;
  public liberarTransacao: boolean = false;
  private transactionInfoBuilder: TransactionInfoBuilder;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private encriptyService: EncriptyUtilService,
    private service: SimulacaoVendaWebtefService,
    public notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private dialogService: NbDialogService,
    public pinPadService: PinPadWebTefService,
    public administrativeService: AdministrativeService,
    public spinnerService: NgxSpinnerService,
    public dateUtilService: DateUtilService,
    private financialService: FinancialService
  ) {
    super(
      notificationService,
      spinnerService,
      dateUtilService,
      pinPadService,
      administrativeService
    );

    this.enterpriseFederalId = this.encriptyService.decriptyBySecretKey(
      localStorage.getItem("bway-enterprise-federal-id")
    );

    this.activatedRoute.queryParams.subscribe((params) => {
      this.valorVenda = this.encriptyService.decriptyBySecretKey(
        params.valorVenda
      );
      this.tipoTaxa = this.encriptyService.decriptyBySecretKey(params.tipoTaxa);
      this.bandeira = this.encriptyService.decriptyBySecretKey(params.bandeira);
      this.modalidade = this.encriptyService.decriptyBySecretKey(
        params.modalidade
      );
    });

    this.pinpadInfo =
      localStorage.getItem('pinpadInfo') == null
        ? null
        : JSON.parse(localStorage.getItem('pinpadInfo'));

    this.formSimulaVenda = this.formBuilder.group({
      valorVenda: [this.valorVenda],
      tipoTaxa: [this.tipoTaxa],
      bandeira: [this.bandeira],
      modalidade: [this.modalidade],
      valorPago: [null],
      valorReceber: [null],
      tipoTransacao: [null],
    });
    this.financial = new Financial();


  }

  ngOnInit() {
   
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
    this.inicializacao();
  }

  inicializacao() {
    this.buscaTerminais();
    let pinpadConfig: any = localStorage.getItem('pinpadConfigWebtef');
    setTimeout(() => {
      this.terminalVerify(pinpadConfig);
    }, 3000);
  }

  ngOnDestroy() {
    this.wsCloseConnection();
  }

  setInitValues() {
    this.listTaxa = [
      {
        tipoTaxa: 'USUARIO',
        descricao: 'USUÁRIO',
      },
      {
        tipoTaxa: 'ESTABELECIMENTO',
        descricao: 'ESTABELECIMENTO',
      },
    ];

    this.listBandeira = [
      {
        bandeira: 'MASTERCARD',
        descricao: 'MASTERCARD',
      },
      {
        bandeira: 'ELO',
        descricao: 'ELO',
      },
      {
        bandeira: 'VISA',
        descricao: 'VISA',
      },
    ];

    this.listTipo = [
      {
        modalidade: 'CREDITO',
        descricao: 'CRÉDITO',
      },
      {
        modalidade: 'DEBITO',
        descricao: 'DEBITO',
      },
    ];
  }

  simula(data: any) {
    this.liberarSelecaoParcelas = false;
    this.valorVenda = data.valorVenda;
    this.spinnerService.show();
    this.service.simularVenda(
      data,
      (response) => {
        this.rowData = response;
        this.liberarSelecaoParcelas = true;
        this.spinnerService.hide();
        this.rowData = this.rowData.map((data) => {
          return {
            parcela: data.parcela,
            valor: data.valor,
            valorCobrar: data.valorCobrar,
            valorReceber: data.valorReceber,
            tipoTaxa: data.tipoTaxa,
            bandeira: data.bandeira,
            modalidadeTransacao: data.modalidadeTransacao,
            valorVenda: data.valorVenda,
          };
        });
      },
      (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      }
    );
  }

  gotoParcela(data) {
    this.parcelaSelecionada = data;
  }

  async pagamento() {
    this.spinnerService.show();

    if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
      this.notificationService.warn('Por favor, selecione uma parcela.');
      return;
    }


    let simuladorInfo: any = null;
    let financialInfo: any = this.createPinpadObject();
    let simulatorInfo: any = this.createSimulatorObject();

    try{
      simuladorInfo = await this.service
      .simularVendaPromise(simulatorInfo)
      .toPromise();
    }catch (err) {
      this.spinnerService.hide();
      this.notificationService.error('Não foi possível realizar venda');
      return;
    }

    simuladorInfo = simuladorInfo.filter(
      (item) => item.selecaoUsuario === true
    );

    this.transactionInfoBuilder = new TransactionInfoBuilder();
    this.transactionInfoBuilder
      .valor(this.financial.valueTransaction)
      .valorSemTaxas(this.valorVenda)
      .qtdParcelas(this.financial.plots)
      .bandeira(this.parcelaSelecionada.bandeira)
      .modalidade(this.parcelaSelecionada.modalidadeTransacao)
      .cpfCnpj(this.enterpriseFederalId)
      .tipoTaxa(this.parcelaSelecionada.tipoTaxa)
      .pinSimuladorId(simuladorInfo[0].id)
      .codigoSimulador(simuladorInfo[0].codigoSimulador)
      .etapaProcessamento(EtapaProcessamento.TRANSACAO_PINPAD_PENDENTE)
      .modeloCaptura('TEF_TI/WEBTEF');

    let pdvReturn: any = null;

    let successHandle: Function = (message, requestData: any) => {
      const info: any = JSON.parse(message.data);

      if (info.Comando === requestData.Comando && info.Status === '00') {

        pdvReturn = info;

        this.transactionInfoBuilder
          .numeroCartao(pdvReturn.NumCartao)
          .codAuth(this.extractInfoFromMsgPdv(pdvReturn.TicketLoja, 'AUT=', 6))
          .codTerm(pdvReturn.NumTerminal)
          .recibo(pdvReturn.TicketLoja)
          .nsuTerminal(String(pdvReturn.NSUTerminal).trim())
          .nsuHost(String(pdvReturn.NSUHost).trim())
          .data(pdvReturn.DataHost)
          .hora(pdvReturn.HoraHost)
          .codigoMensagem(pdvReturn.MsgHost)
          .codigoProcessamento(pdvReturn.CodResposta)
          .reciboUsuario(pdvReturn.TicketPortador)
          .etapaProcessamento(EtapaProcessamento.FINALIZADO);

       this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .subscribe(response => {

          this.showCardModal(this.transactionInfoBuilder.getTransactionInfo());
          this.limparForm();
          this.spinnerService.hide();
          this.subscribe$.unsubscribe();
          this.spinnerService.hide();

          this.notificationService.success('Transacao realizada com sucesso.');
        }, err => {
          this.spinnerService.hide();

          this.notificationService.warn('Não foi possível registar a transação');
        });
      } else if (info.Comando === requestData.Comando && info.Status !== '00') {
        this.service
          .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
          .subscribe((response) => {
            if(info.StatusMessage){
              this.spinnerService.hide();

              this.notificationService.warn(info.StatusMessage);
            }else{
              this.spinnerService.hide();

              this.notificationService.warn('Não foi possível realizar a transacao');
            }
          });
        this.subscribe$.unsubscribe();
      }
    };

    let errorHandle: Function = (err) => {
      this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .subscribe((response) => {
          if(err)
          this.spinnerService.hide();

          this.notificationService.warn('Não foi possível realizar a transacao');
        });
      this.subscribe$.unsubscribe();
    };

    this.wsOpenConnection();

    this.wsVenda(financialInfo, successHandle, errorHandle);
  }

  async asyncRequests() {
    try {
      let vendaInfo: any = null;
      let confirmaVendaInfo: any = null;

      vendaInfo = await this.service
        .vendaPromise(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();

      this.transactionInfoBuilder
        .vendaTx(vendaInfo)
        .etapaProcessamento(EtapaProcessamento.CONFIRMA_VENDA_TX_PENDENTE);

      confirmaVendaInfo = await this.service
        .confirmaVendaPromise(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();

      this.transactionInfoBuilder
        .confirmaVendaTx(confirmaVendaInfo)
        .etapaProcessamento(EtapaProcessamento.FINALIZADO);

      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();
    } catch (error) {
      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();
    }
  }

  createPinpadObject() {
    let type: any = null;
    let typeTransaction: any = null;
    let plots: string = '0';
    if (this.parcelaSelecionada.modalidadeTransacao === 'DEBITO') {
      type = ModalidadeTransacao.DEBITO;
      typeTransaction = '2100';
    } else if (this.parcelaSelecionada.modalidadeTransacao === 'CREDITO' &&  this.parcelaSelecionada.parcela === 1) {
      type = ModalidadeTransacao.CREDITO_VISTA;
      typeTransaction = '2000';
    } else if (this.parcelaSelecionada.modalidadeTransacao === 'CREDITO' && this.parcelaSelecionada.parcela !== 1) {
      type = ModalidadeTransacao.CREDITO_PARCELADO;
      typeTransaction = '2000';
      plots = String(this.parcelaSelecionada.parcela);
    }

    if (!this.pinpadIsInit) {
      this.notificationService.error('Realizar o setup antes de realizar qualquer operação.');
      return;
    }


    this.financial.valueTransaction = Number.parseFloat(String(this.parcelaSelecionada.valorCobrar)
    .replace(',', '.'))
    .toFixed(2);

    this.financial.typeTransaction = typeTransaction;
    this.financial.type = type;
    this.financial.plots = plots;
    this.financial.flag = this.parcelaSelecionada.bandeira;
    return this.financial;
  }

  createSimulatorObject() {
    return {
      valorVenda: this.valorVenda,
      tipoTaxa: this.parcelaSelecionada.tipoTaxa,
      bandeira: this.parcelaSelecionada.bandeira,
      modalidade: this.parcelaSelecionada.modalidadeTransacao,
      qtdParcelas: this.parcelaSelecionada.parcela,
      registraSimulacao: this.parcelaSelecionada.selected,
    };
  }

  extractInfoFromTransaction(value: any): any {
    this.transactionInfoBuilder = new TransactionInfoBuilder();
    this.transactionInfoBuilder
      .numeroCartao(value.pan)
      .codAuth(value.codAuth)
      .codTerm(this.extractInfoFromMsgPdv(value.receipt, "@TERM:", 8));
    return this.transactionInfoBuilder.getTransactionInfo;
  }

  extractInfoFromMsgPdv(msgPdvlue: string, value: string, length: number) {
    const initPosition: number = msgPdvlue.indexOf(value) + value.length;
    const endPosition: number = initPosition + length;
    return msgPdvlue.substring(initPosition, endPosition).trim();
  }

  findTransactionInfo(valueRet: any) {
    this.financialService.findAllTransactions().subscribe((response) => {
      const listRet: any = response;
      valueRet = listRet[listRet.length - 1];
    });
  }

  gerarSimulacao() {
    const promise = new Promise((resolve, reject) => {
      if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
        reject();
      } else {
        const register: any = {
          valorVenda: this.valorVenda,
          tipoTaxa: this.parcelaSelecionada.tipoTaxa,
          bandeira: this.parcelaSelecionada.bandeira,
          modalidade: this.parcelaSelecionada.modalidadeTransacao,
          qtdParcelas: this.parcelaSelecionada.parcela,
          registraSimulacao: this.parcelaSelecionada.selected,
        };
        let itemSelecionado: any = null;
        this.service.simularVenda(
          register,
          (response) => {
            itemSelecionado = response.filter(
              (item) => item.selecaoUsuario === true
            );
            resolve(itemSelecionado);
          },
          (error) => reject(error)
        );
      }
    });
    return promise;
  }

  efetuarTransacao() {
    if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
      this.notificationService.error("Nenhuma parcela selecionada");
      this.spinnerService.hide();
      return;
    } else {
      const register = {
        valorVenda: this.valorVenda,
        tipoTaxa: this.parcelaSelecionada.tipoTaxa,
        bandeira: this.parcelaSelecionada.bandeira,
        modalidade: this.parcelaSelecionada.modalidadeTransacao,
        qtdParcelas: this.parcelaSelecionada.parcela,
        registraSimulacao: this.parcelaSelecionada.selected,
      };

      this.service.simularVenda(
        register,
        (response) => {
          const itemSelecionado = response.filter(
            (item) => item.selecaoUsuario === true
          );

          this.rowData = response;

          if (itemSelecionado[0].selecaoUsuario === true) {
            const register: any = {
              valorVenda: itemSelecionado[0].valorCobrar,
              qtdParcelas: itemSelecionado[0].parcela,
              bandeira: itemSelecionado[0].bandeira,
              modalidadeTransacao: itemSelecionado[0].modalidadeTransacao,
            };

            this.notificationService.success("TRANSAÇÃO EFETUADA COM SUCESSO");
            this.limparForm();
          }
        },
        (error) => {
          this.notificationService.error(error.message);
        }
      );
    }
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45 )) {

      this.formSimulaVenda.controls['valorVenda'].setValue(null);
      this.notificationService.error('Não é permitido números negativos!');

    }
    return true;

  }

  limparForm() {
    this.formSimulaVenda = this.formBuilder.group({
      valorVenda: [null],
      tipoTaxa: [null],
      bandeira: [null],
      modalidade: [null],
      valorPago: [null],
      valorReceber: [null],
    });

    this.rowData = [];
    this.liberarSelecaoParcelas = false;
  }

  showCardModal(data: TransactionInfo) {
    this.dialogService.open(ModalSimulacaoVendaWebtefComponent, {
      context: {
        transactionInfo: data,
      },
    });
  }

  async buscaTerminais() {
    let params = new HttpParams();
    params = params.append('cnpj', this.enterpriseFederalId);
    try {
      this.spinnerService.show();
      let terminalResponse: any = await this.service.buscaTerminaisPromise(params).toPromise()
      terminalResponse = terminalResponse.body;
      this.listTerminais = terminalResponse;
      this.setInitValues();
      this.spinnerService.hide();
      if (this.listTerminais.length === 0) {
        this.notificationService.warn('Não há terminais cadastrados para este estabelecimento');
      }
    }catch (error) {
      this.spinnerService.hide();
      this.notificationService.error('Não foi possivel carregar os terminais');
    }
  }

  previousPage() {
    this.router.navigate(["/iot-dashboard"]);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
